import { Drawer } from "@mui/material";
import { Box } from "@mui/system";

interface FormDrawerProps {
    open: boolean
    //onClose is optional: some callers only close through their form's own
    //cancel button and deliberately ignore backdrop clicks
    onClose?: () => void
    width?: string
    children?: React.ReactNode
}

//FormDrawer is the right-hand panel that holds an add/edit form. maxWidth keeps
//it from overflowing a narrow viewport.
export function FormDrawer(props: FormDrawerProps) {
    return <Drawer anchor="right" open={props.open} onClose={props.onClose}>
        <Box
            display="flex"
            flexDirection="column"
            sx={{
                width: props.width || "580px",
                maxWidth: "100vw",
                padding: "20px",
                flex: 1,
                height: "100%",
            }}
        >
            {props.children}
        </Box>
    </Drawer>;
}

export default FormDrawer;
